// extracted by mini-css-extract-plugin
export var colorSquare = "_n1-0";
export var container = "_n1-h";
export var danger = "_n1-5";
export var lightPink = "_n1-8";
export var neutralBlue = "_n1-7";
export var neutralYellow = "_n1-6";
export var normal = "_n1-1";
export var primary = "_n1-2";
export var primaryLight = "_n1-3";
export var selected = "_n1-i";
export var solidBlack = "_n1-g";
export var solidGreen = "_n1-b";
export var solidLightBlue = "_n1-d";
export var solidNavy = "_n1-c";
export var solidOrange = "_n1-f";
export var solidPink = "_n1-e";
export var solidRed = "_n1-9";
export var solidYellow = "_n1-a";
export var success = "_n1-4";